import React, { useContext } from 'react';
import styles from './style.module.css';
import MobileContext from 'context/MobileContext';
import { Dialog } from '@material-ui/core';
import { polkCloseIcon } from 'assets/newIcons';
import { polkBackground } from 'assets/background-images';

const PolkMemberPopUp = ({ open, setOpenPolkPopUp }) => {
  const isMobile = useContext(MobileContext);

  const handleClose = () => {
    localStorage.setItem('polkMemberPopupClosed', 'true');
    setOpenPolkPopUp(false);
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="polk-popup-title"
      maxWidth={false}
      PaperProps={{
        style: {
          borderRadius: isMobile ? '8px' : '16px',
          background: '#FFF',
          overflow: 'hidden',
          boxShadow: isMobile
            ? '0 4px 6px -1px rgba(0, 0, 0, 0.10)'
            : '0 1px 3px 0 rgba(0, 0, 0, 0.10)',
          ...(isMobile && {
            width: 'calc(100vw - 50px)',
          }),
        },
      }}
    >
      <div className={styles.container}>
        <div
          className={styles.heroBanner}
          style={{ backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), url(${polkBackground})` }}
        >
          <div className={styles.closeWrapper} onClick={handleClose}>
            <img src={polkCloseIcon} alt="close" className={styles.closeIcon} />
          </div>
          <div className={styles.imageCenterBanner}>
            <p className={styles.comingSoon}>Coming Soon</p>
          </div>
        </div>
        <div className={styles.textGroup}>
          <p className={styles.title}>Polk</p>
          <p className={styles.subtitle}>
            1600 Polk Street <span className={styles.subtitleBold}>(Opening in Fall 2026)</span>
          </p>
        </div>
      </div>
    </Dialog>
  );
};

export default PolkMemberPopUp;
